<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="提交时间：">
        <el-date-picker
          v-model="dateTime"
          size="small"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始"
          end-placeholder="结束"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleExport" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import rechargeManualLedgerAuditApi from '@/api/finance/rechargeManualLedgerAudit'
import { filterEmpty } from '@/utils'

export default {
  data() {
    return {
      dateTime: [],
      query: {}
    }
  },
  methods: {
    handleExport() {
      const params = {}
      params.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      params.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common
        .confirm('是否确认导出')
        .then(() => rechargeManualLedgerAuditApi.createExportTask(filterEmpty(params)))
        .then(res => {
          if (res.code === '0') {
            this.$message.success('导出任务已创建')
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          } else {
            this.$message.error(res.msg || '导出失败')
          }
        })
        .catch(err => {
          this.$message.error(err.msg || '导出失败')
        })
    }
  }
}
</script>
